module.exports = __webpack_public_path__ + "assets/img/btn-detail-c09c4273.png";